import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/_drawerLayout/settings/user/")({
  component: RouteComponent,
  beforeLoad: () => {
    return redirect({
      to: "/settings/user/profile",
      replace: true,
    });
  },
});

function RouteComponent() {
  return <></>;
}
